import { ref, watchEffect } from 'vue'

/**
 * Thème clair / sombre (deux modes du design, même mise en page). Le choix est
 * persisté par navigateur ; sans choix, on suit `prefers-color-scheme`. La classe
 * `.dark` sur <html> pilote les jetons (tailwind.css) — `index.html` la pose avant
 * le premier rendu pour éviter un flash.
 */
export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'suivipma-theme'

function initial(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'light' || stored === 'dark') return stored
  } catch {
    /* stockage indisponible */
  }
  return matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

const theme = ref<Theme>(initial())

watchEffect(() => {
  document.documentElement.classList.toggle('dark', theme.value === 'dark')
})

export function useTheme() {
  function setTheme(next: Theme): void {
    theme.value = next
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch {
      /* le choix ne survivra pas au rechargement */
    }
  }
  return { theme, setTheme, toggle: () => setTheme(theme.value === 'dark' ? 'light' : 'dark') }
}
